import { http } from "./http";
import type { NearPosition, SavedVenue, VenueResult } from "../types/venues";

// Venue search for the Venue box (the server asks Google; the key never
// reaches the app). Search never fails loudly: no Google = no results.
// `near`: the phone's rough position once the talent allowed it
// (lib/venueLocation) — the server leans the results toward it.
export const venuesApi = {
  search: (q: string, session: string, signal?: AbortSignal, near?: NearPosition | null) =>
    http.get<{ results: VenueResult[] }>("/venues/search", {
      params: near ? { q, session, lat: near.lat, lng: near.lng } : { q, session },
      signal,
    }),
  /** A picked place (placeId) or a typed name; an empty name removes the venue. */
  save: (venue: { placeId?: string; name: string; session?: string }) => http.put<SavedVenue>("/venues/mine", venue),
};
